import { render, staticRenderFns } from "./tab-instruction.vue?vue&type=template&id=7d8acca5&scoped=true"
import script from "./tab-instruction.vue?vue&type=script&lang=js"
export * from "./tab-instruction.vue?vue&type=script&lang=js"
import style0 from "./tab-instruction.vue?vue&type=style&index=0&id=7d8acca5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8acca5",
  null
  
)

export default component.exports